import React, { useEffect, useState } from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { SessionStorage } from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { getPageType } from '../../helpers/Utils/seoHelper';
import { selectPreferences, selectRequestUrl } from '../../selectors/ContextSelector';
import { setSwitchWidgetSelection } from '../../actions/PLPSwitchWidgetAction';

const PLPSwitchWidget = () => {
    const dispatch = useDispatch();
    const [values, setValues] = useState('Select a Option to view');
    const requestUrl = useSelector((state) => selectRequestUrl(state));
    const pageType = getPageType(requestUrl);
    const plpSwitchWidgetPreferences =
        useSelector((state) => selectPreferences(state))?.plpSwitchWidget || {};

    useEffect(() => {
        const switchWidgetKey = pageType === 'g' ? 'plpSwitchWidget' : 'srpSwitchWidget';
        const selectedValue = SessionStorage.getData(`${switchWidgetKey}SelectedValue`, true);
        const defaultValue = isEmpty(selectedValue)
            ? plpSwitchWidgetPreferences?.[`${switchWidgetKey}DefaultValue`] ||
              (pageType === 'g' ? 'Solr' : 'Bloomreach')
            : selectedValue;

        SessionStorage.setData(`${switchWidgetKey}SelectedValue`, defaultValue, true);
        dispatch(setSwitchWidgetSelection(defaultValue));
        setValues(defaultValue);
    }, [pageType]);

    const handleChange = (event) => {
        const switchWidgetKey = pageType === 'g' ? 'plpSwitchWidget' : 'srpSwitchWidget';
        SessionStorage.setData(`${switchWidgetKey}SelectedValue`, event.target.value, true);
        setValues(event.target.value);
        window.location.reload();
    };

    const bloomreachTextColor = '#DBA204';
    const solrTextColor = '#1191D0';

    const getTextColor = () => {
        let bgColor = '';

        if (values === 'Bloomreach') {
            bgColor = bloomreachTextColor;
        } else if (values === 'Solr') {
            bgColor = solrTextColor;
        }

        return bgColor;
    };

    return (
        <div>
            <label className={dt(['smOnly:text-sm', 'whitespace-nowrap'])}>
                Now viewing:&nbsp;
                <select
                    value={values}
                    onChange={handleChange}
                    className={dt(['smOnly:w-20'])}
                    style={{ color: getTextColor() }}
                >
                    <option value="Select a Option to view" selected disabled>
                        Select a Option to view
                    </option>
                    <option id="solr" value="Solr" style={{ color: solrTextColor }}>
                        SOLR
                    </option>
                    <option
                        id="bloomreach"
                        value="Bloomreach"
                        style={{ color: bloomreachTextColor }}
                    >
                        Bloomreach
                    </option>
                </select>
            </label>
        </div>
    );
};

export default PLPSwitchWidget;
